import { MouseEventHandler, ReactNode} from "react";
import { ButtonProps } from "react-bootstrap";
import FloatingOverlay from "../tooltips/FloatingOverlay";
import CoreButton from "./CoreButton";

export const defaultToolips = {
  NO_PERMISSION: "You do not have permission to perform this action",
  LIMIT_HIT: "You are not able to create more stories until you've ordered your first story"
}

export type EnhancedButtonProps = ButtonProps & {
  isLoading? : boolean
  onClick? : MouseEventHandler,
  className? : string,
  containerClassName? : string,
  tooltip? : string,
  isWarning? : boolean,
  warningOnClick? : MouseEventHandler,
  disabledTooltip? : string,
  overlayComponent? : ReactNode,
  block? : boolean,
  circle? : boolean,
  variant? : string,
  children? : ReactNode,
  [key: string] : unknown
}

export const EnhancedButton = ({isLoading, onClick, className, containerClassName, tooltip, isWarning, warningOnClick, disabled, disabledTooltip, overlayComponent, block, children, circle, variant, ...childProps} : EnhancedButtonProps) => {

  return (
    <>
      {disabledTooltip && disabled ? (
          <FloatingOverlay overlayComponent={overlayComponent ? overlayComponent : <div className="tooltip-inner">{disabledTooltip}</div>}>
              <div className={`mb-2 ${block ? "d-grid" : ""}`} style={{display: "inline-block"}}>
                <CoreButton variant={variant} circle={circle} isLoading={isLoading} disabled={disabled} isWarning={isWarning} className={className} containerClassName={containerClassName}onClick={isWarning ? warningOnClick : onClick} {...childProps} >{children}</CoreButton>
              </div>
          </FloatingOverlay>
      ) : tooltip ? (
          <FloatingOverlay overlayComponent={overlayComponent ? overlayComponent : <div className="tooltip-inner">{tooltip}</div>}>
            <CoreButton variant={variant} circle={circle} block={block} isLoading={isLoading} disabled={disabled} isWarning={isWarning} className={className} containerClassName={containerClassName} onClick={isWarning ? warningOnClick : onClick} {...childProps} >{children}</CoreButton>
          </FloatingOverlay>
        ) : <CoreButton variant={variant} circle={circle} block={block} isLoading={isLoading} disabled={disabled} isWarning={isWarning} className={className} containerClassName={containerClassName} onClick={isWarning ? warningOnClick : onClick} {...childProps} >{children}</CoreButton>
      }
    </>
  );
}